import { BaseDto } from "./base.dto"
import { PagingDto } from "./paging.dto"

export class AdminFindFrequentlyAskedQuestionDto extends PagingDto {
  type?: string
}

export class AdminFrequentlyAskedQuestionDto extends BaseDto {
  question: string
  questionKh: string
  answer: string
  answerKh: string
  enabled: boolean
  type: string

  static create() {
    return new AdminFrequentlyAskedQuestionDto()
  }
}

export class AdminCreateFrequentlyAskedQuestionDto {
  question: string
  questionKh: string
  answer: string
  answerKh: string
  enabled: boolean
}

export class AdminUpdateFrequentlyAskedQuestionDto {
  question?: string
  questionKh?: string
  answer?: string
  answerKh?: string
  enabled?: boolean
}

export class AdminSortOrderFrequentlyAskedQuestionDto {
  ids: string[]
}